var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      staticClass: "os-order-row",
      class: { "green lighten-2": _vm.highlighted },
      on: {
        click: function($event) {
          return _vm.highlightItem()
        }
      }
    },
    [
      _vm._l(_vm.fieldsMain, function(field, index) {
        return [
          _c("field-input", {
            key: field.id,
            ref: "childinput",
            refInFor: true,
            class: { "pl-3": !index },
            attrs: {
              assignment_type: _vm.type + "item",
              assignment_id: _vm.row.id,
              availableassignments: _vm.availableassignments
                ? _vm.availableassignments[field.id]
                : null,
              column: field.id === _vm.productField.id ? "product_id" : null,
              edit: _vm.editing,
              editDisabled: _vm.editDisabled,
              field: field,
              inlineEdit: _vm.inlineEdit,
              inlineSave: _vm.inlineSave,
              keyedFieldvalues: _vm.scopeFieldvalues,
              overrideConfig: _vm.overrides ? _vm.overrides[field.id] : null,
              rowindex: _vm.rowindex,
              setDefault: !_vm.viewform || !_vm.row.id,
              singleLine: true,
              table: true,
              value: _vm.scopeFieldvalues[field.id][_vm.rowindex],
              viewform: _vm.viewform
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
              },
              inputChanged: _vm.inputChanged
            }
          })
        ]
      }),
      _vm._v(" "),
      _vm.$store.state.pricetypes.length > 1
        ? _c(
            "td",
            {
              class:
                _vm.priceOverrides["pricetype"].visibility === "visible"
                  ? "px-2"
                  : "px-0",
              style: {
                minWidth:
                  _vm.priceOverrides["pricetype"].visibility === "visible" &&
                  (_vm.editing || _vm.editingprice)
                    ? "130px;"
                    : ""
              }
            },
            [
              _vm.editDisabled || (!_vm.editing && !_vm.editingprice)
                ? _c(
                    "span",
                    { staticClass: "subheading" },
                    [
                      _vm.priceOverrides["pricetype"].visibility === "visible"
                        ? [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.keyedPriceTypes[_vm.row.pricetype_id]
                                    ? _vm.keyedPriceTypes[_vm.row.pricetype_id]
                                        .name
                                    : ""
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _c("v-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.priceOverrides["pricetype"].visibility ===
                          "visible",
                        expression:
                          "priceOverrides['pricetype'].visibility === 'visible'"
                      }
                    ],
                    ref: "fieldinput",
                    attrs: {
                      disabled: _vm.priceOverrides["pricetype"].read_only,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Price Type",
                      required: "",
                      "single-line": "",
                      items: _vm.pricetypes,
                      rules: [!!_vm.scopepricetype || "This field is required"],
                      value: _vm.scopepricetype
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      },
                      input: _vm.pricetypeChanged
                    }
                  })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "td",
        {
          class:
            _vm.priceOverrides["price"].visibility === "visible"
              ? "px-2"
              : "px-0",
          style: {
            minWidth:
              _vm.priceOverrides["price"].visibility === "visible" &&
              (_vm.editing || _vm.editingprice)
                ? "142px;"
                : ""
          }
        },
        [
          _vm.editDisabled || (!_vm.editing && !_vm.editingprice)
            ? _c(
                "span",
                { staticClass: "subheading" },
                [
                  _vm.priceOverrides["price"].visibility === "visible"
                    ? [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm._f("pricefilter")(_vm.row.price)) +
                            "\n\t\t\t\t"
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            : _c("v-text-field", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.priceOverrides["price"].visibility === "visible",
                    expression:
                      "priceOverrides['price'].visibility === 'visible'"
                  }
                ],
                ref: "fieldinput",
                attrs: {
                  disabled: _vm.priceOverrides["price"].read_only,
                  label: "Price",
                  prefix: "£",
                  required: "",
                  "single-line": "",
                  "append-icon": _vm.price.fixed ? "lock" : null,
                  readonly: _vm.price.fixed,
                  rules: [
                    function(value) {
                      var pattern = /^[0-9]+(\.[0-9]{1,2})?$/
                      return (
                        (!!value && pattern.test(value)) || "Invalid price."
                      )
                    }
                  ],
                  value: _vm.scopeprice
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  },
                  input: _vm.priceChanged
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          class:
            _vm.priceOverrides["total"].visibility === "visible"
              ? "px-2"
              : "px-0",
          style: {
            minWidth:
              _vm.priceOverrides["price"].visibility === "visible" &&
              (_vm.editing || _vm.editingprice)
                ? "142px;"
                : ""
          }
        },
        [
          _vm.editDisabled || (!_vm.editing && !_vm.editingprice)
            ? _c(
                "span",
                { staticClass: "subheading" },
                [
                  _vm.priceOverrides["total"].visibility === "visible"
                    ? [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm._f("pricefilter")(_vm.row.total)) +
                            "\n\t\t\t\t"
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            : _c("v-text-field", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.priceOverrides["total"].visibility === "visible",
                    expression:
                      "priceOverrides['total'].visibility === 'visible'"
                  }
                ],
                attrs: {
                  disabled: _vm.priceOverrides["total"].read_only,
                  label: "Total",
                  prefix: "£",
                  readonly: "",
                  "single-line": "",
                  value: _vm.rowPrice
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.editDisabled
        ? _c(
            "td",
            {
              staticClass: "px-0",
              attrs: {
                width: !_vm.viewform
                  ? "40px"
                  : _vm.inlineSave
                  ? "115px"
                  : "80px"
              }
            },
            [
              _c(
                "v-slide-y-reverse-transition",
                { attrs: { mode: "out-in" } },
                [
                  _c(
                    "div",
                    {
                      key: "transition-" + _vm.editing + "-" + _vm.editingprice,
                      staticClass: "fill-height"
                    },
                    [
                      _vm.viewform
                        ? [
                            _vm.inlineEdit
                              ? [
                                  !_vm.editingprice
                                    ? [
                                        _vm.showEditButton
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "ma-0 os-btn os-hover-btn",
                                                class: {
                                                  "os-touch-device":
                                                    _vm.touchdevice
                                                },
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.editingprice = true
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { color: "info" } },
                                                  [
                                                    _vm._v(
                                                      "mdi-circle-edit-outline"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    : [
                                        _vm.inlineSave
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass: "ma-0 os-btn",
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.savePrice($event)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: { color: "success" }
                                                  },
                                                  [_vm._v("mdi-check-outline")]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "ma-0 os-btn",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.cancelPrice($event)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { color: "error" } },
                                              [
                                                _vm._v(
                                                  "mdi-close-circle-outline"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                ]
                              : [
                                  !_vm.editing
                                    ? [
                                        !_vm.editDisabled
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "ma-0 os-btn os-rowhover-btn",
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.$emit(
                                                      "setEdit",
                                                      _vm.row.id,
                                                      true
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { color: "info" } },
                                                  [
                                                    _vm._v(
                                                      "mdi-circle-edit-outline"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    : [
                                        _vm.inlineSave
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass: "ma-0 os-btn",
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.saveRow($event)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: { color: "success" }
                                                  },
                                                  [_vm._v("mdi-check-outline")]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.row.id
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass: "ma-0 os-btn",
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.cancelEdit(
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { color: "error" } },
                                                  [
                                                    _vm._v(
                                                      "mdi-close-circle-outline"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                ],
                            _vm._v(" "),
                            !_vm.editDisabled && _vm.canEditItems
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "ma-0 os-btn os-rowhover-btn float-right",
                                    attrs: { icon: "" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.deleteOrderitem($event)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "error" } },
                                      [_vm._v("mdi-delete-outline")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : [
                            !_vm.editDisabled
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 os-btn os-rowhover-btn",
                                    attrs: { icon: "" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.$emit(
                                          "deleteOrderitem",
                                          _vm.rowindex
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "error" } },
                                      [_vm._v("mdi-delete-outline")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.fieldsStatus, function(field) {
        return [
          _c("field-input", {
            key: field.id,
            ref: "childinput",
            refInFor: true,
            attrs: {
              assignment_type: _vm.type + "item",
              assignment_id: _vm.row.id,
              availableassignments: _vm.availableassignments
                ? _vm.availableassignments[field.id]
                : null,
              column: field.id === _vm.productField.id ? "product_id" : null,
              edit: _vm.editing,
              field: field,
              inlineEdit: _vm.inlineEdit,
              inlineSave: _vm.inlineSave,
              keyedFieldvalues: _vm.scopeFieldvalues,
              overrideConfig: _vm.overrides ? _vm.overrides[field.id] : null,
              rowindex: _vm.rowindex,
              setDefault: !_vm.viewform || !_vm.row.id,
              singleLine: true,
              table: true,
              value: _vm.scopeFieldvalues[field.id][_vm.rowindex],
              viewform: _vm.viewform,
              editDisabled: _vm.editDisabled
            },
            on: { inputChanged: _vm.inputChanged }
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-322a834c", { render: render, staticRenderFns: staticRenderFns })
  }
}